// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltipHolder[data-v-0505f004]{position:relative;display:inline-block;margin-left:10px}.tooltipHolder .tooltiptext[data-v-0505f004]{background:#9ad86d;color:#555;border-radius:50%;font-size:.8125em;width:18px;height:18px;display:inline-block;line-height:20px;text-align:center}.tooltipHolder .tooltiptext[data-v-0505f004]:hover{transition:all .1s ease-in-out;scale:1.1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
